import { ForgotPasswordPayload, SetPasswordPayload, SetPasswordResponseData } from './types';
import apiClient from 'apiClient';

export const setPasswordRequest = (payload: SetPasswordPayload): Promise<SetPasswordResponseData> => {
  return apiClient.post('/api/v1/auth/password/set', payload).then((res) => res.data);
};

export const forgotPasswordRequest = (payload: ForgotPasswordPayload): Promise<any> => {
  return apiClient.post('/api/v1/auth/password/reset-token', payload).then((res) => res.data);
};

export const verifyToken = (token: string): Promise<any> => {
  return apiClient.post('/api/v1/auth/password/verify-token', { token: token });
};
